module.exports = __webpack_public_path__ + "fonts/RobotoMono-Bold.8c6b0b80.woff";